import React from 'react'
import { commonRoutes } from 'common';
import { Route, Redirect } from 'react-router-dom';
import { CheckAccess } from 'common/abilityHelpers';

const PrivateRoute = ({ path: RoutePath, component: Component, access: setAccess, ...rest }) => {
    const isAuthentic = true;

    const getAccess = setAccess;
    const canAccess = (getAccess) ? CheckAccess(getAccess) : true;
    if ( getAccess?.length && getAccess[0] === 'powerbi:sustainability:read' && RoutePath === commonRoutes.reportsAnalytics && !canAccess) {
        return (
            <Route {...rest} path={RoutePath} render={props => ((isAuthentic && canAccess) ? <Component {...props} /> : <Redirect to={commonRoutes.reportsAnalyticsSecondary} />)} />
        )
    } 

    return (
        <Route {...rest} path={RoutePath} render={props => ((isAuthentic && canAccess) ? <Component {...props} /> : <Redirect to="/" />)} />
    )
}

export default PrivateRoute
